export default "__VITE_PUBLIC_ASSET__226ed1b5__"